import types from "./types";
import StoreTypes from "../../../store/types";

const initialState = {
  firstName: "",
  middleName: "",
  lastName: "",
  maritalStatus: "",
  gender: "",
  dateOfBirth: "",
  state: "",
  country: "",
  hasPet: false,
  incapacityPlan: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.MARITAL_STATUS:
      return { ...state, maritalStatus: action.payload };

    case types.SET_NAME:
      return {
        ...state,
        firstName: action.payload.firstName,
        middleName: action.payload.middleName,
        lastName: action.payload.lastName,
      };

    case StoreTypes.SET_DETAILS:
      return {
        ...state,
        firstName: action.payload.basic?.firstName,
        middleName: action.payload.basic?.middleName,
        lastName: action.payload.basic?.lastName,
        maritalStatus: action.payload.basic?.maritalStatus,
        dateOfBirth: action.payload.basic?.dateOfBirth,
        gender: action.payload.basic?.gender,
        state: action.payload.basic?.state,
        country: action.payload.basic?.country,
        hasPet: action.payload.basic?.hasPet,
        incapacityPlan: action.payload.basic?.incapacityPlan,
        hasChildren: action.payload.basic?.hasChildren,
        hasOtherChildren: action.payload.basic?.hasOtherChildren,
      };

    case types.SET_INCAPACITY_PLAN:
      return { ...state, incapacityPlan: action.payload };

    case types.SET_DOB:
      return { ...state, dateOfBirth: action.payload };

    case types.SET_GENDER:
      return { ...state, gender: action.payload };

    case types.SET_STATE:
      return { ...state, state: action.payload };

    case types.SET_PET:
      return { ...state, pets: action.payload };

    default:
      return state;
  }
};

export default reducer;
